import { HttpHeaders } from '@angular/common/http';

export const getCaptchaHeaders = (captchaToken: string, recaptchaSiteKey: string): HttpHeaders => {
  if (recaptchaSiteKey !== '' && captchaToken) {
    return new HttpHeaders().set('X-Captcha-Response', captchaToken).set('X-Captcha-Site-Key', recaptchaSiteKey);
  } else {
    return new HttpHeaders();
  }
};
